export default "__VITE_ASSET__303b7f01__"